export default __webpack_public_path__ + "static/media/243.42bb0254.gif";